export default __webpack_public_path__ + "static/media/kitchen_audios.023c971d.mp3";